export default __webpack_public_path__ + "2267169ee7270a22a963b2b2bfb7ab0c.woff";